import classNames from 'classnames';
import isNil from 'lodash/isNil';
import React, { type JSX } from 'react';

import './VStack.less';

// ==============================
// TYPES
// ==============================
type VStackSharedProps = {
  className?: string;
  children: React.ReactNode;
};

/** Anonymous numeric gap xor named preset — never both. */
type VStackProps =
  | (VStackSharedProps & {
    align?: 'center';
    gap: 4 | 8 | 12 | 16;
    // ----------
    preset?: never;
  })
  | (VStackSharedProps & {
    preset: 'page' | 'section';
    // ----------
    align?: never;
    gap?: never;
  });

// ==============================
// COMPONENTS
// ==============================
/** Vertical flex column. */
function VStack(props: VStackProps): JSX.Element {
  const { align, children, className, gap, preset } = props;
  return (
    <div
      className={classNames(
        'VStack',
        !isNil(gap) && `vertical-gap-${gap}`,
        !isNil(preset) && `VStack--preset-${preset}`,
        align && `VStack--align-${align}`,
        className
      )}
    >
      {children}
    </div>
  );
}

export { VStack };
export type { VStackProps };
